import React, { useEffect, useRef, useState } from 'react';
import { useAddProductContext } from '../../../Contexts/AddProductContext';
import SlotStep from './SlotStep';
import { TbChevronLeft, TbAlertSquareRounded, TbMoodConfuzed, TbPhotoX, TbShare } from 'react-icons/tb';
import Button from '../../Form/Button';
import { useCartContext } from '../../../Contexts/CartContext';
import DOMPurify from 'dompurify';
import Img from '../Img';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';
import CartService from '../../../Services/CartService';
import { useStoreContext } from '../../../Contexts/StoreContext';
import { ImSpinner8 } from 'react-icons/im';
import { PRODUCT_TYPE_COMPOSITE, PRODUCT_TYPE_SIMPLE } from '../../../Utils/Constants/Product';
import ProductPrice from './ProductPrice';
import AddProductObservation from './AddProductObservation';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import BadgeNewProduct from './BadgeNewProduct';
import BadgeProductSale from './BadgeProductSale';
import { useProductsHook } from '../../../Hooks/ProductsHook';
import BoxContentEndScrollbars from '../BoxContentEndScrollbars';
import TitleProduct from './TitleProduct';
import { useStoreHook } from '../../../Hooks/StoreHook';
import ButtonLink from '../../Form/ButtonLink';
import { useTranslation } from 'react-i18next';
import BoxContentTags from './BoxContentTags';
import BadgeProductTagFlag from './BadgeProductTagFlag';
import AddProductFooterButtons from './AddProductFooterButtons';
import { vibrate } from '../../../Utils/Helpers';
import { useCheckoutContext } from '../../../Contexts/CheckoutContext';
import Modal from '../Modal';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { useNavigate } from 'react-router-dom';
import { ORDER_TYPE_STORE_COUNTER_ID } from '../../../Utils/Constants/Service';

interface AddProductProps {
    product: any;
    category: any;
    onCancel: CallableFunction;
}

const AddProduct = ({
    product,
    category,
    onCancel = () => {},
}: AddProductProps) => {

const { t } = useTranslation();
const { setShowAddProduct } = useAddProductContext();
const { addCartTempInConference, setAddProductCartTemp, cartTemp, cartDisplay, currentSteps, setCurrentSteps, setDisabledButtonAddProduct, getPriceTotalSelectedComplements, cartConference, currentCart, loadingCurrentCart, setLoadingCurrentCart, loadingUpdateQuantity, returnToCheckout, getTotalSelectedComplements } = useCartContext();
const { orderType, getOrderTypeIdByName, isStoreCounter, isDelivery } = useOrderTypeContext();
const [height] = useState('45vh');
const [fixedTitle, setFixedTitle] = useState(false);
const fixedTitleRef = useRef<HTMLDivElement | null>(null);
const description = DOMPurify.sanitize(product.description);
const [currentProduct, setCurrentProduct] = useState<any>(product);
const [currentPrice, setCurrentPrice] = useState<number>(0);
const [loadingSteps, setLoadingSteps] = useState(product.type === PRODUCT_TYPE_COMPOSITE);
const { currentStore } = useStoreContext();
const { createGuestToken, getActiveCart, getLinkToHome } = useStoreHook();
const { company, isMobile, setMainLoading, setMainLoadingIcon, setMainLoadingIconSuccess, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, setEnableLoadProducts, setMainLoadingIconClick } = useLayoutContext();
const { sendProducts } = useProductsHook();
const { order } = useCheckoutContext();
const [showModalReturnToOrder, setShowModalReturnToOrder] = useState(false);
const navigate = useNavigate();

type InvalidStepResult = {
  index: number;
  step: any | null;
};

useEffect(() => {

    if (fixedTitleRef.current) {
        const updatePosition = () => {
            if (fixedTitleRef.current) {
                const posFixedTitle = fixedTitleRef.current.getBoundingClientRect();
                setFixedTitle(posFixedTitle.top <= 0);
            }
        };

        updatePosition();
        window.addEventListener("scroll", updatePosition);
        window.addEventListener("resize", updatePosition);

        return () => {
            window.removeEventListener("scroll", updatePosition);
            window.removeEventListener("resize", updatePosition);
        };
    }
}, []);

const isFirstRender = useRef(true);

const autoScrollSteps = (stepIndex: number, autoNext:boolean=false) => {

    const nextStepIndex = autoNext ? stepIndex + 1 : stepIndex;
    const nextElement = document.getElementById(`step_${nextStepIndex}`);
    if (!nextElement) return;
    setTimeout(() => { //* only for layout
        nextElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 350);
}

const handleShare = async () => {
    if (navigator.share) {
        try {
            await navigator.share({
                // title: product.name,
                // text: product.name + ' - ' + product.description,
                url: window.location.href,
            });
        } catch (err) {}
    }
};

useEffect(() => {
    //* Rolagem automática inicial para steps do produto composto
    const initialScrollForCompositeProduct = currentSteps && currentSteps.length > 0 && isFirstRender.current && isMobile && product.type === PRODUCT_TYPE_COMPOSITE;
    if (initialScrollForCompositeProduct) {
        const boxScroll = document.getElementById('scrollContent_addProduct');
        isFirstRender.current = false;
        if (boxScroll) {
            boxScroll.scrollTo({ top: 200, behavior: 'smooth' });
        }
    }

// eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentSteps])

const handleCancel = () => {
    setTimeout(() => { //* only for layout
        setCurrentSteps([]);
    }, 250);

    document.title = currentStore.name || company.name;

    setEnableLoadProducts(false);
    onCancel();
}

const handProductToAdd = () => {
    const categoryId = category?.id ?? currentProduct?.categories?.[0]?.id ?? 1;
    setAddProductCartTemp({...currentProduct, currentCategoryId: categoryId});
}

// obtem o index do primeiro item obrigatório não selecionado
const getFirstInvalidRequiredStep = (): InvalidStepResult => {
  if (!Array.isArray(currentSteps)) {
    return { index: -1, step: null };
  }

  const index = currentSteps.findIndex((step: any) => {
    if (!step?.required) return false;

    const totalSelected = getTotalSelectedComplements(step.id);
    return totalSelected < step.minimum_quantity;
  });

  if (index === -1) {
    return { index: -1, step: null };
  }

  return {
    index,
    step: currentSteps[index]
  };
};

const handleRequiredStep = () => {
    const { index } = getFirstInvalidRequiredStep();

    if (index === -1) return;

    if (!isMobile) {
        setMainLoading(true);
        setMainLoadingIcon(false);
        setMainLoadingIconClick(true);
        setMainLoadingTitle(t('add_product.steps.required_step_title'));
        setMainLoadingCloseButton(true);
    }

    // Rolando até o primeiro step obrigatório não selecionado
    autoScrollSteps(index);
    shakeRequiredStep();
    vibrate(1000);
};

// Efeito shake no badge required
const shakeRequiredStep = () => {
    const stepsRequired = document.getElementsByClassName("stepRequired");
    if (stepsRequired.length > 0) {
        Array.from(stepsRequired).forEach((element: any) => {
            element.classList.add('animate-shake-once');
            element.classList.remove('animate-pulse');
            element.classList.add('bg-shopfood-notify');
            element.classList.remove('bg-shopfood-required');
        });

        setTimeout(() => {
            Array.from(stepsRequired).forEach((element: any) => {
                element.classList.remove('animate-shake-once');
                element.classList.add('animate-pulse');
                element.classList.remove('bg-shopfood-notify');
                element.classList.add('bg-shopfood-required');
            });
        }, 4000); // Tempo de duração do shake
    }
}

const handleAdd = () => {

    if (isStoreCounter && order?.type === ORDER_TYPE_STORE_COUNTER_ID) {
        setShowModalReturnToOrder(true);
        return;
    }

    setEnableLoadProducts(false);

    if (!isStoreCounter && !currentCart?.cart_id) {
        //* Criando guestToken e cart
        setLoadingCurrentCart(true);
        const orderTypeId = Number(getOrderTypeIdByName(orderType));
        createGuestToken(currentStore.id, orderTypeId)
            .then((resp: any) => {
                const payload = {
                    store_id: currentStore.id,
                    order_type_id: orderTypeId,
                    order_type: orderType
                }
                getActiveCart(payload)
                    .then(() => handProductToAdd())
                    .catch(() => setLoadingCurrentCart(false));
        })
        .catch(() => setLoadingCurrentCart(false));
    } else {
        handProductToAdd();
    }
}

useEffect(() => {
    if (cartTemp.length > 0) {
            addCartTempInConference();
        if (isStoreCounter) {
            setShowAddProduct(false);
        }
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [cartTemp]);

useEffect(() => {
    if (!isStoreCounter && cartConference.length > 0) {
        cartConference.forEach((item: any) => {
            const payload = {
                order_type: Number(getOrderTypeIdByName(orderType)),
                product_id: item.complementable_id ?? item.id,
                quantity: item.quantity,
                observation: item.observation ?? '',
                ...(isDelivery && {shipping_value: currentStore.shipping_value}),
                ...(item.steps && item.steps.length > 0 && { steps: item.steps })
            }

            sendProducts(currentCart.cart_id, payload)
                .then(() => {
                    if (returnToCheckout) {
                        setMainLoadingIcon(false);
                        setMainLoadingIconSuccess(true);
                        setMainLoadingCloseButton(true);
                        setMainLoadingTitle(t('add_product.redirect_to_checkout.title'));
                        setMainLoadingMessage(t('add_product.redirect_to_checkout.message'));
                        setMainLoading(true);
                    }
                })
                .catch((error) => {});
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [cartConference]);

const handleObservation = (newObservation: string) => {
    setCurrentProduct({...currentProduct, observation: newObservation})
};

useEffect(() => {
    setCurrentProduct({...currentProduct, quantity: 1})
    setCurrentSteps([]);
    setEnableLoadProducts(false);

    return () => {
        setCurrentSteps([]);
    };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

const handleUpdateProduct = (quantity: number) => {
    setCurrentProduct({...currentProduct, quantity: quantity});
}

useEffect(() => {
    const getStepsAndComplements = async () => {
        const payload = {
            store_id: currentStore.id,
            product_id: product.id,
            order_type: Number(getOrderTypeIdByName(orderType)),
        }
        try {
            const cartService = new CartService(orderType);
            const getSteps = await cartService.stepsAndComplements(payload);
            if (getSteps) {
                setCurrentSteps(getSteps.product.product_composite_steps);
            }
        } catch (error: any) {
            setCurrentSteps([]);
        } finally {
            setLoadingSteps(false);
        }
    }

    if (product.type === PRODUCT_TYPE_COMPOSITE) {
        getStepsAndComplements();
    }

// eslint-disable-next-line react-hooks/exhaustive-deps
}, [product?.id, cartDisplay, currentCart])

useEffect(() => {

    if (currentSteps) {
        setDisabledButtonAddProduct(
            loadingSteps
            || loadingCurrentCart
            || loadingUpdateQuantity
        );

        if (currentSteps.length > 0) {
            setCurrentPrice(getPriceTotalSelectedComplements())
            setCurrentProduct((prevProduct: any) => ({
                ...prevProduct,
                price: getPriceTotalSelectedComplements()
            }));
        } else {
            setCurrentPrice(product.price)
            setCurrentProduct((prevProduct: any) => ({
                ...prevProduct,
                price: product.price
            }));
        }
    }

// eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentSteps, loadingCurrentCart, loadingUpdateQuantity]);

const handleRedirectToCheckout = () => {
    setShowModalReturnToOrder(false);
    setShowAddProduct(false);
    navigate(`${getLinkToHome()}/order/${order.id}/view`);
}

return (
    <>
    <section className="flex flex-col justify-between h-full md:h-[80dvh]">

        <div className="relative h-full min-h-24">

            <div id='scrollContent_addProduct' className='flex flex-col gap-4 w-full h-full overflow-y-auto md:max-h-[80vh]' >
                <div className='md:flex gap-4 h-full w-full'>

                    <div className={`inline md:flex md:flex-col h-full md:top-0 ${product.type === PRODUCT_TYPE_COMPOSITE ? 'md:self-start md:w-3/6 md:sticky' : 'w-full'}`}>
                        {product.photos?.medium
                            ?
                                <div id="boxImage" className="relative md:hidden z-10 sticky top-0 block w-full bg-no-repeat bg-fixed bg-cover bg-center bg-gray-50" style={{height, backgroundImage: `url('${product.photos.medium}')`}}>
                                    <Button outline rounded onClick={() => handleCancel()} className='fixed left-3 top-3 text-white ring-transparent hover:ring-transparent active:ring-transparent bg-gray-900/20 active:brightness-150 hover:constrast-150'>
                                        <div><TbChevronLeft size={25} /></div>
                                    </Button>
                                </div>
                            :   <Img src={product.photos?.medium} fallback={
                                    <div className='relative md:hidden flex items-center justify-center w-full h-full bg-gray-100' style={{height}}>
                                        <TbPhotoX size={50} className='text-white' />
                                        <Button rounded onClick={() => handleCancel()} className='fixed left-3 top-3 text-white ring-transparent hover:ring-transparent active:ring-transparent bg-gray-800/10 active:brightness-150 hover:constrast-150'>
                                            <div><TbChevronLeft size={25} /></div>
                                        </Button>
                                    </div>
                                    } alt={product.name} className="w-full"
                                />
                        }

                        {/* Title Top (desktop) */}
                        <div className='hidden md:flex md:flex-col md:flex-grow w-full text-left md:pb-20'>
                            <div className="flex flex-col h-[409dvh] max-h-fit justify-center overflow-hidden">

                                {product.type === PRODUCT_TYPE_COMPOSITE &&
                                    <div className={`
                                        flex items-center w-full justify-center rounded-tl-xl rounded-br-xl overflow-hidden self-start
                                        ${product.photos?.medium && 'aspect-square h-max'}
                                    `}>
                                        {product.photos.medium
                                            ?   <Img src={product.photos?.medium} alt={product.name} className="w-full transition-width ease-in-out duration-200" />
                                            :   <TbPhotoX size={50} className='text-white' />
                                        }
                                    </div>
                                }

                                {product.type === PRODUCT_TYPE_SIMPLE &&
                                    <div className='
                                    flex items-center w-full justify-center md:p-1.5
                                    min-h-[45vh]
                                    md:rounded-t-xl
                                    bg-no-repeat bg-cover bg-center
                                    bg-gray-50
                                    '
                                    style={{height, backgroundImage: `url('${product.photos.medium}')`}}
                                    >
                                        {!product.photos.medium && <TbPhotoX size={50} className='text-gray-200' />}
                                    </div>
                                }

                                <div className="flex flex-col w-full flex-1 h-auto gap-2 p-4 pb-2 text-left">
                                    <h2 className='text-2xl font-bold text-shopfood-title'>
                                        {product.name}

                                        {/* PRODUCT TAG FLAG  */}
                                        <BadgeProductTagFlag product={product} className='inline-block ml-1.5' />
                                    </h2>
                                </div>

                                <div className="flex flex-col w-full flex-1 h-auto gap-2 p-4 pb-2 text-left">

                                    {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                                    <BadgeNewProduct product={product} className='flex-inline self-start rounded -mr-0.5' />

                                    {/* PRODUCT SALE  */}
                                    <BadgeProductSale product={product} className='flex-inline self-start rounded -mr-0.5' />

                                    {/* PRICE */}
                                    <div className='font-medium text-gray-500 text-nowrap leading-none'>
                                        <ProductPrice product={product} breakLine={false} />
                                    </div>

                                    <div className='flex flex-col gap-4'>
                                        {/* DESCRIPTION */}
                                        {description && <p className='text-sm text-left leading-4 text-gray-500 md:mt-2' dangerouslySetInnerHTML={{ __html: description }} />}

                                        {/* TAGS */}
                                        <BoxContentTags product={product} />

                                        {/* OBSERVATION */}
                                        {((!isStoreCounter && product.type === PRODUCT_TYPE_SIMPLE) || (isStoreCounter && cartDisplay && product.type === PRODUCT_TYPE_SIMPLE)) &&
                                            <AddProductObservation onHandleObservation={(e: any) => handleObservation(e) } observation={currentProduct.observation} />
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div className={`relative md:w-full md:h-full bg-white sticky z-20 ${product.type !== PRODUCT_TYPE_COMPOSITE && 'md:hidden'}`}>

                        {product.type === PRODUCT_TYPE_COMPOSITE &&
                            <div className="absolute z-20 left-0 right-0 -top-8">
                                <div className="w-10 bg-gray-300 h-[4px] mx-auto rounded-full" />
                            </div>
                        }

                        <section className={`relative md:p-4 md:pb-0 md:pr-2 md:pl-0 h-full flex flex-col ${loadingSteps ? 'md:overflow-hidden' : 'md:overflow-y-auto'}`}>

                            {/* Header/Title Side (mobile) */}
                            <header className='md:hidden'>


                                <div ref={fixedTitleRef} className={`flex items-center justify-between gap-1 w-full text-left p-3 pl-4 pb-2 md:p-4 -mt-10 sticky top-0 bg-white shadow-reverse-lg transition-all ease-in-out duration-300 ${fixedTitle ? 'rounded-t-none' : ' rounded-t-2xl'}`}>
                                    <TitleProduct product={product} className={`${product.type === PRODUCT_TYPE_COMPOSITE && 'mt-1'}`} />
                                    <ButtonLink rounded onClick={handleShare} className='self-start bg-transparent focus:bg-transparent'><div><TbShare size={20} /></div></ButtonLink>
                                </div>

                                {/* PRICE */}
                                <div className='p-4 pt-0 font-medium text-left text-nowrap leading-none'>
                                    <ProductPrice product={product} breakLine={false} />
                                </div>

                                <div className='flex flex-col gap-4 text-left p-4 pt-0 md:mb-0'>
                                    {/* DESCRIPTION */}
                                    <p className='text-left leading-5 text-gray-500' dangerouslySetInnerHTML={{ __html: description }} />

                                    {/* TAGS */}
                                    <BoxContentTags product={product} />

                                    {/* OBSERVATION */}
                                    {((!isStoreCounter && product.type === PRODUCT_TYPE_SIMPLE) || (isStoreCounter && cartDisplay && product.type === PRODUCT_TYPE_SIMPLE)) &&
                                        <AddProductObservation onHandleObservation={(e: any) => handleObservation(e) } observation={currentProduct.observation} />
                                    }
                                </div>

                            </header>

                            {product.type === PRODUCT_TYPE_COMPOSITE &&
                                <div className={`flex flex-col gap-4 mt-2 mb-20 md:mb-0 md:mt-0 md:pl-0.5 ${loadingSteps ? 'md:min-h-full' : '' }`}>
                                    {loadingSteps
                                        ?
                                            <div className="flex items-center md:justify-center gap-1 min-h-full text-gray-400 px-4 pt-4">
                                                <ImSpinner8 className="animate-spin" />
                                                <span>{t('add_product.steps.loading')}</span>
                                            </div>
                                        :
                                        currentSteps.length === 0
                                            ?   <div className='h-full flex items-center md:bg-gray-50 rounded-xl md:justify-center gap-1 px-4 pt-4 text-gray-400'><TbMoodConfuzed /> <span>{t('add_product.steps.no_products_found')}</span></div>
                                            :   <div className='flex flex-col gap-8 md:gap-6'>{currentSteps.map((step: any, index: number) => <SlotStep product={product} step={step} key={index} stepIndex={index} scrollToNextStepWithOffset={() => autoScrollSteps(index, true)} />)}</div>
                                    }

                                    {!loadingSteps && currentSteps.length > 0 && (
                                        <BoxContentEndScrollbars
                                            show={!loadingSteps && currentSteps.length > 0}
                                            message={t('products.end_of_list')}
                                        />
                                    )}

                                    {/* Footer buttons */}
                                    {!isMobile &&
                                        <AddProductFooterButtons
                                            product={currentProduct}
                                            loading={loadingSteps}
                                            currentPrice={currentPrice}
                                            onCancel={handleCancel}
                                            onUpdateProduct={handleUpdateProduct}
                                            onAdd={handleAdd}
                                            onRequiredStep={handleRequiredStep}
                                            className='z-50'
                                        />
                                    }

                                </div>
                            }

                        </section>
                    </div>

                </div>
            </div>

            {/* Footer buttons */}
            {(product.type === PRODUCT_TYPE_SIMPLE || (isMobile && product.type === PRODUCT_TYPE_COMPOSITE)) &&
                <AddProductFooterButtons
                    product={currentProduct}
                    loading={loadingSteps}
                    currentPrice={currentPrice}
                    onCancel={handleCancel}
                    onUpdateProduct={handleUpdateProduct}
                    onAdd={handleAdd}
                    onRequiredStep={handleRequiredStep}
                    className='sticky bottom-0'
                />
            }

        </div>

    </section>

        <Modal open={showModalReturnToOrder} className="max-w-sm m-4" onClose={() => setShowModalReturnToOrder(false)} closeable={true}>
            <section className='flex flex-col items-center w-full p-6 gap-8'>
                <h4 className='flex flex-col items-center'>
                    <span className='mb-2'>
                        <TbAlertSquareRounded size={55} className="zoomInIcon" />
                    </span>
                    <span className='font-extrabold text-2xl mb-2 leading-6'>{ t('checkout.orders_open.title') }</span>
                    <span className='leading-5'>{ t('add_product.redirect_to_checkout.message') }</span>
                </h4>

                <div className='flex flex-wrap justify-center gap-2 w-full'>
                    <ButtonPrimary onClick={() => handleRedirectToCheckout()} className="flex-1 text-nowrap">{ t('layout.confirm.label_close_button') }</ButtonPrimary>
                </div>
            </section>
      </Modal>
    </>
  )
}

export default AddProduct;